<div class="wrapper">
  <h1>Loading</h1>
  <div class="loading-dots-wave">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</div>
